import React from "react";
import { CalendarDays, Clock, CheckCircle2, HeartPulse, AlertTriangle, XCircle } from "lucide-react";
import { Card } from "./ui";

const CARDS = [
  { key: "today", label: "Today's Cases", icon: CalendarDays, color: "text-navy", bg: "bg-navy/10" },
  { key: "pending", label: "Pending Cases", icon: Clock, color: "text-slate-600", bg: "bg-slate-100" },
  { key: "completed", label: "Completed Cases", icon: CheckCircle2, color: "text-teal", bg: "bg-teal-light" },
  { key: "fit", label: "Accepted", icon: HeartPulse, color: "text-emerald-600", bg: "bg-emerald-50" },
{ key: "temp_unfit", label: "Further Evaluation Required", icon: AlertTriangle, color: "text-amber-600", bg: "bg-amber-50" },
{ key: "unfit", label: "Not Recommended", icon: XCircle, color: "text-red-600", bg: "bg-red-50" },
];

export default function StatCards({ stats, hide = [] }) {
  return (
    <div className="stagger grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
      {CARDS.filter(({ key }) => !hide.includes(key)).map(({ key, label, icon: Icon, color, bg }) => (
        <Card key={key} className="p-5 transition-transform hover:-translate-y-1 hover:shadow-sm" data-testid={`stat-card-${key}`}>
          <div className={`mb-3 inline-flex rounded-md p-2 ${bg}`}>
            <Icon size={18} className={color} />
          </div>
          <p className="font-heading text-3xl font-extrabold text-slate-900" data-testid={`stat-value-${key}`}>
            {stats ? stats[key] : "-"}
          </p>
          <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
        </Card>
      ))}
    </div>
  );
}
